import {SUBMIT_RSVP} from './constants';

const INIT_FROM_CLIENT_DATA = 'ViewInvitation/user/initUser';

const initialState = {
  userId: '',
  guestId: window.guest_id || '',
  name: '',
  email: '',
  isHost: false,
  isRegistered: false,
  hasUserOptedOut: window.viewingUser?.hasUserOptedOut || false,
};

export function initUser(viewingUser) {
  return {
    type: INIT_FROM_CLIENT_DATA,
    viewingUser,
  };
}

export function initHashedEmails(clientData) {
  return {
    type: INIT_FROM_CLIENT_DATA,
    emailMd5: clientData.evc_h,
    emailSha256: clientData.evc_s256l,
  };
}

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INIT_FROM_CLIENT_DATA:
      return {
        ...state,
        ...action.viewingUser,
        isAuthenticated: !!action.viewingUser?.isLoggedIn,
        guestId: state.guestId || action.viewingUser?.guestId || '',
        emailMd5: action.emailMd5 || '',
        emailSha256: action.emailSha256 || '',
      };
    case SUBMIT_RSVP: {
      const {guest} = action.results;
      return {
        ...state,
        guestId: guest.id,
        userId: guest.user_id,
        // The RSVP response's 'host' value is not reliable so we
        // keep the existing isHost flag unless the guestId changes.
        isHost: state.guestId === guest.id ? state.isHost : false,
        name: guest.name,
        email: guest.email,
        isRegistered: action.results.is_registered_user,
      };
    }
    default:
      return state;
  }
}
